// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2iDXD","header":"MessagesList_header__13puA","chat":"MessagesList_chat__2hLkA"};